(function () {

  'use strict';

  function pxSettingsContextMenu() {
    return {
      restrict: 'E',
      scope: {
        context: '=context',
        selectedTab: '=selectedTab',
        resource: '=resource',
        tenant: '=tenant',
        auxiliaries: '=auxiliaries',
        callback: '&callback',
        updateParent: '&updateParent'
      },
      templateUrl: 'app/components/settings/_settingsContextMenu/settingsContextMenu.template.html',
      link: function (scope, element, attrs) {

        scope.closePopup = function (context) {
          scope.callback({ context: context || false });
        };

        scope.relayUpdateParent = function () {
          scope.updateParent();
        };

      }
    };
  }

  pxSettingsContextMenu.$inject = [];

  angular
    .module('printix-admin')
    .directive('pxSettingsContextMenu', pxSettingsContextMenu);

})();
